module.exports = __webpack_public_path__ + "static/fds-logo-83222b398d953d8eeea09a860c0e1392.png";